import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput"

import { Row, Col, Label, Input, InputGroup, InputGroupAddon, FormFeedback, Collapse } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            nombre: '',
            host: '',
            username: '',
            password: '',
            port:''
        };

    }

    static propTypes = {
        onSubmit: PropTypes.func,        
        nav: PropTypes.any
    }

    getData = () => {
        const { nombre, host, username, password, port } = this.state;
        return { nombre, host, username, password, port };
    }

    resetForm() {
        this.setState({
            nombre: '',
            host: '',
            username: '',
            password: '',
            port:''
        });
        if (this.props.onClose) this.props.onClose();
    }
   

    render() {
        return (
            <span>
            <ParadigmaModal
                onPreSubmit={this.getData}
                postUrl={api.email.casillas.create}
                navButton={(this.props.nav ? true : false)}
                nav={this.props.nav}
                onSubmit={(e) => this.props.onSubmit(e)}
                successMessage={"La Casilla de Mail ha sido generada con éxito."}
                title={"Nueva Casilla de Mail"}
                buttonTitle={"Nueva"}
                className=""
                buttonIcon={"fa fa-plus fa-lg"}
                saveButton={true}
                closeButton={true}
                onClose={() => this.resetForm()}
                initOpen={this.props.initOpen}
                cancelButtonLabel="Cancelar"
            >

                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Nombre"}
                            fieldName={"nombre"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.nombre}
                            onChange={e => this.setState({ nombre: e.target.value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Host"}
                            fieldName={"host"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.host}
                            onChange={e => this.setState({ host: e.target.value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Usuario"}
                            fieldName={"username"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.username}
                            onChange={e => this.setState({ username: e.target.value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Contraseña"}
                            fieldName={"password"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.password}
                            onChange={e => this.setState({ password: e.target.value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Puerto"}
                            fieldName={"port"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.port}
                            onChange={e => this.setState({ port: e.target.value })}
                        />
                    </Col>
                </Row>


            </ParadigmaModal>
            </span>
        );
    }
}

export default Create;


// WEBPACK FOOTER //
// ./src/views/Config/Casillas/Create.js